import "../../styles/index.css";

const Resume = () => {
    return (  
        <div className="Resume page" id="resume">
            <br />
            <h2>Resume</h2>
            <br/><p>Current as of 9 Jun 2023</p><br />
            <iframe src="https://dark-obsidia.github.io/dark-obsidia/documents/Nunez%207_14.pdf" type="application/pdf" frameborder="0" title="Resume"></iframe>
        </div>
    );
}
 
export default Resume;